import { FC } from 'react';

interface PrimaryButtonType {
    text: string;
    onClick?: () => void;
    className?: string;
    disabled?: boolean;
}

const PrimaryButton: FC<PrimaryButtonType> = ({
    text,
    onClick,
    className,
    disabled = false,
    ...args
}) => {
    return (
        <button
            onClick={onClick}
            className={`button-primary ${className || ''}`}
            disabled={disabled}
            {...args}
        >
            {text}
        </button>
    );
};

export default PrimaryButton;
